import React from "react";
import { Dialog as MUIDialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@material-ui/core";
import { useIntl, MessageDescriptor } from "react-intl";
import type { FC } from "react";

import { useStyles } from "./FavouritesDialog.styles";
import type { IFavouritesDialogProps } from "./FavouritesDialog.types";

export const FavouritesDialog: FC<IFavouritesDialogProps> = (props) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const { title, contentText, actions = [], handleCloseDialog, children, onClose, alignActions = "center", ...MUIProps } = props;

  const formatStringOrMessage = (value: string | MessageDescriptor): string => {
    if (typeof value === "string") {
      return value;
    }
    return formatMessage(value);
  };

  return (
    <MUIDialog classes={{ paper: classes.root }} onClose={onClose || handleCloseDialog} {...MUIProps}>
      {title && <DialogTitle className={classes.title}>{formatStringOrMessage(title)}</DialogTitle>}
      <DialogContent>
        {contentText && <DialogContentText className={classes.contentText}>{formatStringOrMessage(contentText)}</DialogContentText>}
        {children}
      </DialogContent>
      {actions.length > 0 && (
        <DialogActions className={alignActions === "left" ? classes.actionsLeft : undefined}>
          {actions.map((action, index) => (
            <Button
              key={index}
              onClick={action.handleClick || handleCloseDialog}
              variant="contained"
              color="primary"
              className={classes.actionButton}
            >
              {formatStringOrMessage(action.name)}
            </Button>
          ))}
        </DialogActions>
      )}
    </MUIDialog>
  );
};
